export default __webpack_public_path__ + "static/ex3-signature-9682188a64f4de8e7a3debda3c2de0dc.webp";